import { pxToRem } from '../../../../utils';
export var reactionGroupVariables = function reactionGroupVariables() {
  return {
    reactionSpacing: pxToRem(8)
  };
};